import React from 'react';
import './Modal.css';
import taskIcon from "../../assets/images/Icon=Tasks.svg"
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';

const CreateTaskModal = ({ isVisible, onClose }) => {
    return (
        isVisible && (
            <div className="modal-backdrop">
                <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                    <div className='content-container'>
                        <div className='icon-container'>
                            <img src={taskIcon} />
                        </div>
                        <div className='text-container'>
                            <Heading6Semibold color='#1E293B' text='Create Tasks' />
                            <BodyMediumRegular
                                color='#384153'
                                text='This action will generate tasks for every added plan, you can always edit tasks in the task list.'
                                textAlign='center'
                            />
                        </div>
                    </div>
                    <div className='button-contiainer'>
                        <button className='cancel-button'
                            onClick={onClose}
                        >
                            <BodyExtraSmallMedium color='#1E293B' text='Cancel' />
                        </button>
                        <button className='primary-button'>
                            <BodyExtraSmallMedium color='#FFFFFF' text='Create Tasks' />
                        </button>

                    </div>
                </div>
            </div>
        )
    );
};

export default CreateTaskModal;
